/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */

/**
 *  Prestige
 */

/**LOG IN */
export const SEND_LOGIN_REQUEST = 'SEND_LOGIN_REQUEST'
export const SEND_LOGIN_COMPLETE = 'SEND_LOGIN_COMPLETE'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'

/**SIGN UP */
export const SEND_SIGNUP_REQUEST = 'SEND_SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAILED = 'SIGNUP_FAILED'

/**ACTIVE ACCOUNT CHECK ACTIVATE CODE*/
export const SEND_ACTIVEACCOUNT_REQUEST = 'SEND_ACTIVEACCOUNT_REQUEST'
export const ACTIVEACCOUNT_SUCCESS = 'ACTIVEACCOUNT_SUCCESS'
export const ACTIVEACCOUNT_FAILED = 'ACTIVEACCOUNT_FAILED'

/**Get Activate code */
export const SEND_ACTIVATECODE_REQUEST  = 'SEND_ACTIVATECODE_REQUEST'
export const SEND_ACTIVATECODE_SUCCESS  = 'SEND_ACTIVATECODE_SUCCESS'
export const SEND_ACTIVATECODE_FAILED  = 'SEND_ACTIVATECODE_FAILED'

/**CHECK PASSWORD RESET CODE */
export const SEND_CHECKPASSWORDRESETCODE_REQUEST  = 'SEND_CHECKPASSWORDRESETCODE_REQUEST'
export const CHECKPASSWORDRESETCODE_SUCCESS  = 'CHECKPASSWORDRESETCODE_SUCCESS'
export const CHECKPASSWORDRESETCODE_FAILED  = 'CHECKPASSWORDRESETCODE_FAILED'

/**FORGET PASSWORD */
export const SEND_FORGETPASSWORD_REQUEST = 'SEND_FORGETPASSWORD_REQUEST'
export const FORGETPASSWORD_SUCCESS = 'FORGETPASSWORD_SUCCESS'
export const FORGETPASSWORD_FAILED = 'FORGETPASSWORD_FAILED'


/** NEW PASSWORD*/
export const SEND_NEWPASSWORD_REQUEST = 'SEND_NEWPASSWORD_REQUEST'
export const NEWPASSWORD_SUCCESS = 'NEWPASSWORD_SUCCESS'
export const NEWPASSWORD_FAILED = 'NEWPASSWORD_FAILED'

/**PROMOTION INFO */
export const SEND_PROMOTIONINFO_REQUEST = 'SEND_PROMOTIONINFO_REQUEST'
export const SEND_PROMOTIONINFO_COMPLETE = 'SEND_PROMOTIONINFO_COMPLETE'

export const PROMOTIONINFO_SUCCESS = 'PROMOTIONINFO_SUCCESS'
export const PROMOTIONINFO_FAILED = 'PROMOTIONINFO_FAILED'

/*STANDARD ERRORS HANDING */
export const REQUEST_ERROR = 'REQUEST_ERROR'

export const CLEAR_ERROR = 'CLEAR_ERROR'